/**
* List metadata related constants
*/
var Metadata = {
  REQUIRED_METADATA_TIMEOUT: 10000
}
module.exports = Metadata
